/**
 * 접속 기기 플랫폼 판별.
 *
 * Windows 메신저(HubCore 메신저)는 Windows 10/11 전용이라 설치 버튼·안내는 Windows 에서만 보여야 한다.
 * - Chromium 계열은 navigator.userAgentData.platform 이 "Windows" 로 정확하다.
 * - 그 외(Firefox 등)는 UA 의 "Windows NT" 로 판별한다. 모바일 브라우저의 "데스크톱 사이트" 모드는
 *   Linux/Mac UA 를 보내므로 Windows 로 오판되지 않는다.
 */
export function isWindowsDesktop(): boolean {
  if (typeof navigator === "undefined") return false;
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  if (uaData?.platform) return uaData.platform === "Windows";
  return /Windows NT/.test(navigator.userAgent);
}

/** Android 브라우저 (앱 APK 를 바로 받아 설치할 수 있는 기기) */
export function isAndroid(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent);
}

/** iPhone/iPad — Android 앱은 설치할 수 없다 */
export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
